var jade = require("/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<dokumente doc-anzeige=\"vm.parameter.anzeigeart\" docpk=\"vm.obj\" doc-permissions=\"vm.obj.user_permissions\" snapshot=\"vm.snapshot\" snapshotdiff=\"vm.snapshotdiff\" dokumente-permissions=\"vm.dokumentePermissions\" condition=\"vm.dokumenteCondition\" update-status=\"vm.updateStatus\" obj=\"vm.obj\" dokumentnotizen=\"vm.dokumentnotizen\" notiz-options=\"vm.notizoptions\" notizkey=\"vm.notizkey\" html-id=\"vm.htmlId\"></dokumente>");;return buf.join("");
}